import { useEffect } from "react";
import sentryService from "services/SentryService";
import { useAuthStore } from "stores/authStore";

export const useSyncSentryUser = () => {
  const id = useAuthStore(s => s.currentUserId);
  const email = useAuthStore(s => s.email);
  const fullName = useAuthStore(s => s.fullName);
  const useRights = useAuthStore(s => s.useRights);

  useEffect(() => {
    if (!id) {
      sentryService.setUser();
      return;
    }

    sentryService.setUser({
      id,
      email,
      fullName,
      useRights,
    });
  }, [id, email, fullName, useRights]);
};
